export default __webpack_public_path__ + "media/images/brands/the-just-slate-company-d7392d15df121ca4070da302aff64e44.png";